/**
 * TEXT-LIST
 * Liste de textes courts saisis a la suite, une ligne par element :
 * Entree cree une ligne juste en dessous, Retour arriere sur une ligne vide la supprime et remonte.
 */
import { useRef } from "react"
import TextInput from "./text-input"

interface Props {
  title?: string
  values: string[]
  onChange: (values: string[]) => void
  //Assistant de chaque ligne : proposer une ligne vide, retravailler une ligne remplie
  assistantIdeaPrompt?: string
  getAssistantImprovePrompt?: (value: string) => string
}

export default function TextList({ title, values, onChange, assistantIdeaPrompt, getAssistantImprovePrompt }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)
  //Toujours au moins une ligne a remplir
  const lines = values.length ? values : [""]

  //La ligne cible n'existe qu'apres le rendu : le focus attend la frame suivante
  function focusLine(index: number) {
    requestAnimationFrame(() => containerRef.current?.querySelectorAll("input")[index]?.focus())
  }

  function handleKeyDown(key: string, index: number) {
    if (key === "Enter") {
      onChange([...lines.slice(0, index + 1), "", ...lines.slice(index + 1)])
      focusLine(index + 1)
    }
    if (key === "Backspace" && !lines[index] && lines.length > 1) {
      onChange(lines.filter((_, i) => i !== index))
      focusLine(Math.max(0, index - 1))
    }
  }

  return (
    //Entree cree une ligne : elle ne doit pas remonter jusqu'a la modale, qui validerait
    <div ref={containerRef} onKeyDown={(event) => event.key === "Enter" && event.stopPropagation()}>
      {title && <div className="text-input-title grey-t mb-10">{title}</div>}
      <div className="flex flex-col gap-[8px]">
        {lines.map((value, index) => (
          <TextInput
            key={index}
            value={value}
            width="100%"
            assistantIdeaPrompt={value.trim() ? undefined : assistantIdeaPrompt}
            assistantImprovePrompt={value.trim() ? getAssistantImprovePrompt?.(value) : undefined}
            onChange={(e) => onChange(lines.map((line, i) => (i === index ? e.value : line)))}
            onKeyDown={(key) => handleKeyDown(key, index)}
          />
        ))}
      </div>
    </div>
  )
}
